import { useLanguage } from "@/App";
import { translations } from "@/i18n";
import { Reveal, Eyebrow } from "@/components/Reveal";

const IMG =
  "https://images.unsplash.com/photo-1779700210487-a01758a3c55a?auto=format&fit=crop&w=1400&q=80";
const FALLBACK =
  "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1400";

const About = () => {
  const { lang } = useLanguage();
  const t = translations[lang].about;

  return (
    <section id="about" data-testid="about-section" className="bg-[#0A1128] py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid items-center gap-16 lg:grid-cols-12 lg:gap-20">
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow>{t.eyebrow}</Eyebrow>
              <h2 className="font-display text-4xl font-black tracking-tighter text-white sm:text-5xl">
                {t.title}
              </h2>
              <p className="mt-8 text-base font-light leading-relaxed text-slate-300 md:text-lg">
                {t.p1}
              </p>
              <p className="mt-6 text-base font-light leading-relaxed text-slate-300 md:text-lg">
                {t.p2}
              </p>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="mt-12 grid grid-cols-3 divide-x divide-white/10 border-y border-white/10">
                {t.stats.map((s, i) => (
                  <div key={`${lang}-${i}`} className="px-4 py-8 first:pl-0" data-testid={`about-stat-${i}`}>
                    <p className="font-display text-lg font-black text-[#D4AF37] md:text-2xl">
                      {s.value}
                    </p>
                    <p className="mt-2 text-xs font-light text-slate-400 md:text-sm">{s.label}</p>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>

          <Reveal className="lg:col-span-6" delay={0.1}>
            <div className="relative">
              <div className="absolute -right-4 -bottom-4 h-full w-full border border-[#D4AF37]/40" />
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={IMG}
                  onError={(e) => {
                    if (e.currentTarget.src !== FALLBACK) e.currentTarget.src = FALLBACK;
                  }}
                  alt="KOAM consulting team in a meeting"
                  className="h-full w-full object-cover grayscale-[35%] transition-[filter] duration-700 hover:grayscale-0"
                />
                <div className="absolute inset-0 bg-[#0A1128]/20" />
                <span className="absolute bottom-6 left-6 font-kr text-5xl font-black text-white/15">
                  한미
                </span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
